export default __webpack_public_path__ + "static/media/blog-details-thumb-1.f3f8c27d.jpg";